import React from 'react';
import { useConsentManager } from './hooks';
export const ConsentManager = ({ serviceId, children }) => {
    const [hasConsent] = useConsentManager(serviceId);
    return hasConsent ? React.createElement(React.Fragment, null, children) : null;
};
